var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSysConnectivityAndDistribution = function SvgSysConnectivityAndDistribution(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12.03 5.415a.946.946 0 1 0 0 1.892.946.946 0 0 0 0-1.892Zm-1.946.946a1.946 1.946 0 1 1 3.892 0 1.946 1.946 0 0 1-3.892 0ZM17.623 14.926a.946.946 0 1 0 0 1.892.946.946 0 0 0 0-1.892Zm-1.946.946a1.946 1.946 0 1 1 3.892 0 1.946 1.946 0 0 1-3.892 0ZM6.377 14.926a.946.946 0 1 0 0 1.892.946.946 0 0 0 0-1.892Zm-1.946.946a1.946 1.946 0 1 1 3.892 0 1.946 1.946 0 0 1-3.892 0Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M6.959 16.666a.5.5 0 0 1 .706.025 5.954 5.954 0 0 0 7.31 1.107.5.5 0 0 1 .496.868 6.954 6.954 0 0 1-8.537-1.293.5.5 0 0 1 .025-.707ZM15.06 6.92a.5.5 0 0 1 .69-.152 6.967 6.967 0 0 1 2.919 7.885.5.5 0 0 1-.958-.29 5.968 5.968 0 0 0-2.5-6.753.5.5 0 0 1-.151-.69ZM11.066 6.229a.5.5 0 0 1-.376.598 5.955 5.955 0 0 0-4.623 5.633.5.5 0 0 1-1-.028 6.955 6.955 0 0 1 5.4-6.58.5.5 0 0 1 .6.377Z",
    clipRule: "evenodd"
  })));
};
export default SvgSysConnectivityAndDistribution;